const $ = window.jQuery;

export default class Utils {
    static removeTrailingSlash(path) {
        return path.charAt(path.length - 1) === "/"
            ? path.substr(0, path.length - 1)
            : path;
    }

    static addTrailingSlash(path) {
        // console.log( path.match( /[\?]/g ) );
        return path + (path.charAt(path.length - 1) === "/" ? "" : "/");
    }

    static getUrlLocation(url) {
        var l = document.createElement("a");
        l.href = url;
        return l.host;
    }

    static isExternalUrl(url) {
        return (
            url.indexOf(":") > -1 &&
            this.getUrlLocation(location.href) !== this.getUrlLocation(url)
        );
    }

    static elementIsUnderMouse(event, el) {
        var x = event.clientX,
            y = event.clientY;

        //special bonus for those using jQuery
        if (typeof $ === "function" && el instanceof $) {
            el = el[0];
        }
        var rect = el.getBoundingClientRect();

        return (
            rect.left <= x &&
            rect.top <= y &&
            rect.right >= x &&
            rect.bottom >= y
        );
    }

    static elementIsInViewport(el, threshold) {
        //special bonus for those using jQuery
        if (typeof $ === "function" && el instanceof $) {
            el = el[0];
        }

        var rect = el.getBoundingClientRect();
        var viewportHeight =
            window.innerHeight || document.documentElement.clientHeight;
        var viewportWidth =
            window.innerWidth || document.documentElement.clientWidth;

        return (
            rect.top >= 0 + threshold &&
            rect.left >= 0 + threshold &&
            rect.bottom <=
                viewportHeight - threshold /*or $(window).height() */ &&
            rect.right <= viewportWidth - threshold /*or $(window).width() */
        );
    }

    static setPrefixedCss($el, property, value) {
        var el = $el[0];

        el.style["webkit" + property] = value;
        el.style["Moz" + property] = value;
        el.style["ms" + property] = value;
        el.style["O" + property] = value;

        var nativeProperty =
            property.substr(0, 1).toLowerCase() + property.substr(1);
        el.style[nativeProperty] = value;
    }

    static hslToRgb(h, s, l) {
        var r, g, b;

        if (s == 0) {
            r = g = b = l; // achromatic
        } else {
            var hue2rgb = function hue2rgb(p, q, t) {
                if (t < 0) t += 1;
                if (t > 1) t -= 1;
                if (t < 1 / 6) return p + (q - p) * 6 * t;
                if (t < 1 / 2) return q;
                if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
                return p;
            };

            var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
            var p = 2 * l - q;
            r = hue2rgb(p, q, h + 1 / 3);
            g = hue2rgb(p, q, h);
            b = hue2rgb(p, q, h - 1 / 3);
        }

        return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255)];
    }

    static isElementInDom($el) {
        return $.contains(document, $el[0]);
    }

    static getScrollPercent() {
        return (
            $(document).scrollTop() /
            ($(document).height() - $(window).height())
        );
    }
}
